const getPageFromOffset = (offset = 0, limit = 1) => offset / limit + 1;

export default getPageFromOffset;
